export default __webpack_public_path__ + "static/media/product-banner3.3ad47e6c.png";